import { render } from "./ConfigDs.vue?vue&type=template&id=0d192494&scoped=true&ts=true"
import script from "./ConfigDs.vue?vue&type=script&lang=ts"
export * from "./ConfigDs.vue?vue&type=script&lang=ts"

import "./ConfigDs.vue?vue&type=style&index=0&id=0d192494&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d192494"]])

export default __exports__